// extracted by mini-css-extract-plugin
module.exports = {"navBarBtn":"BankStatementInsight-module--navBarBtn--25ZnM"};